import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IBankDetail } from "../bankModel";

export const getAllActiveBanks = createAsyncThunk(
  "Bank/FindAllActiveBank",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Bank/FindAllActiveBank`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Banks:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllBanks = createAsyncThunk("Bank/FindAllBank", async () => {
  try {
    const response = await axiosApiInstance.post(
      `${API_URL}/Bank/FindAllBank`,
      {
        BankName: "",
      }
    );
    return response.data?.Data;
  } catch (error: any) {
    // ErrorToast(error?.response?.data?.Details || "Something went wrong");
    console.error("Error Fetching Banks:", error);
    return Promise.reject({
      message: error?.response?.data?.Details || "Something went wrong",
    });
  }
});

export const createBank = createAsyncThunk(
  "Bank/InsertBank",
  async (FormData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Bank/InsertBank`,
        FormData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Bank:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateBank = createAsyncThunk(
  "Bank/UpdateBank",
  async (FormData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Bank/UpdateBank`,
        FormData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Bank:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteBank = createAsyncThunk(
  "Bank/DeleteBank",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Bank/DeleteBank`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Bank:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getBankByID = createAsyncThunk(
  "Bank/FindByIDBank",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Bank/FindByIDBank`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        BankName: result.BankName,
        IsActive: result?.IsActive ? 1 : 2,
      } as IBankDetail;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Bank:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveBank = createAsyncThunk(
  "Bank/ActiveInActiveBank",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Bank/ActiveInActiveBank`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Bank:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
